import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(({
  root: {backgroundColor: "#fafdff",
    borderRadius: 16
  },
  cardHeaderRoot: {
    minHeight: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    padding: 'clamp(8px, calc(1px + 0.55vw), 12px) clamp(10px, calc(2px + 0.625vw), 16px)',
    boxSizing: 'border-box',
    '& .MuiCardHeader-content': {
      overflow: 'hidden',
    },
    '& .MuiCardHeader-title': {
      fontSize: 'clamp(0.66rem, calc(0.291rem + 0.549vw), 0.95rem)',
      fontWeight: 700,
      color: '#002D55',
      lineHeight: 1.2,
      paddingLeft: 5,
    },
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: "#fafdff",
  },
  Button: {
    color: "#FFFFFF",
    backgroundColor: "#002D55"
  }
}));

const Notifications = ({ className, selectedPatient, ...rest }) => {
  const classes = useStyles();

  return (
    <form
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card className={clsx(classes.root, className)}>
      <CardHeader
          className={classes.cardHeaderRoot}
          title="Settings"
          subheader="Manage notifications and messages."
          style={{color: "#002D55", marginBottom: 0}}
          variant="h4"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={6}
            wrap="wrap"
          >
            <Grid
              className={classes.item}
              item
              md={4}
              sm={6}
              xs={12}
            >
              <Typography
                style={{color: "#002D55"}}
                gutterBottom
                variant="h6"
              >
                Notifications
              </Typography>
              <FormControlLabel
                control={(
                  <Checkbox defaultChecked style={{color: "#f79400"}}/>
                )}
                label="Email"
                style={{color: "#002D55"}}
              />
              <FormControlLabel
                control={(
                  <Checkbox defaultChecked style={{color: "#f79400"}}/>
                )}
                label="Push Notifications"
                style={{color: "#002D55"}}
              />
              <FormControlLabel
                control={<Checkbox style={{color: "#f79400"}}/>}
                label="Text Messages"
                style={{color: "#002D55"}}
              />
            </Grid>
            <Grid
              className={classes.item}
              item
              md={4}
              sm={6}
              xs={12}
            >
              <Typography
                style={{color: "#002D55"}}
                gutterBottom
                variant="h6"
              >
                Messages
              </Typography>
              <FormControlLabel
                control={(
                  <Checkbox defaultChecked style={{color: "#f79400"}}/>
                )}
                label="Email"
                style={{color: "#002D55"}}
              />
              <FormControlLabel
                control={<Checkbox style={{color: "#f79400"}}/>}
                label="Push Notifications"
                style={{color: "#002D55"}}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider style={{marginTop: 13.5}}/>
        <Box
          display="flex"
          justifyContent="flex-end"
          p={2}
          
        >
          <Button
            className={classes.Button}
            variant="contained"
          >
            Save settings
          </Button>
        </Box>
      </Card>
    </form>
  );
};

Notifications.propTypes = {
  className: PropTypes.string
};

export default Notifications;